import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductCard from "components/ProductCard";
import ProductCardTheme2 from "components/ProductCardTheme2";
import Pagination from "components/Common/Pagination";
import { updateActivePage } from "redux/actions";
import "./product-items.scss";
import AdsSpaceSectionMainTheme2 from "routes/individual-departmentTheme2/AdsSpaceSectionMainTheme2";
import { useLocation } from 'react-router-dom';

const ProductList = ({
  productList,
  activePageNo,
  productListByDepartmentTotalPages,
  bannerData
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isReorderPage = location.pathname === "/department/reorder";

  const [page, setPage] = useState(activePageNo);

  const { theme_type } = useSelector(
    ({ common }) => common.commonDetailsData.header_section || {}
  );

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const handleSetPage = (data) => {
      dispatch(updateActivePage(data));
      scrollToTop();
      setPage(data);
  };
  
  const departmentTitles = isReorderPage ? [...new Set(productList.map((i) => i.department_name))] : ["test"];
  const [OrderDepartments, setOpenDepartments] = useState(
    departmentTitles.reduce((acc, title) => {
      acc[title] = true
      return acc
    }, {})
  )

  const toggleDepartment = (title) => {
    setOpenDepartments((prev) => {
      const oldValue = prev[title] === undefined ? true : prev[title];
      return ({ ...prev, [title]: !oldValue })
    });
  };
 

  return (
    <div className="deal-all-wrapper">
      {departmentTitles?.map((title) => {

        const products = isReorderPage ? productList.filter((p) => p.department_name === title) : productList;
        
        // Split productList into two separate lists if bannerData is not null
        let firstHalf = products;
        let secondHalf = [];
        if (bannerData && bannerData.length > 0 && products.length > 10) {
          const middleIndex = Math.floor(products.length / 2);
          firstHalf = products.slice(0, middleIndex);
          secondHalf = products.slice(middleIndex);
        }

        return (
        <div key={title} className="department-sction">
          {isReorderPage ? <div
              className="department-title-wrap"
              onClick={() => toggleDepartment(title)}
            >
              <h2 className="department-title">{title}</h2>
              <DownArrowIcon isOpen={OrderDepartments[title] !== false} />
        </div> : null}
          {(OrderDepartments[title] !== false || !isReorderPage) && (
          <>
      <div className="product-list-grid">
        {theme_type === "1" && firstHalf.length > 0 ?
          (firstHalf.map((product, index) => {
            return (
              <div className="product-list-grid-items" key={product.product_id || index}>
                <ProductCard product={product} />
              </div>
            );
          })) : (
            firstHalf.map((product, index) => {
              return (
                <div className="product-list-grid-items" key={product.product_id || index}>
                  <ProductCardTheme2 product={product} />
                </div>
              );
            })
          )
        }
      </div>
      {bannerData && bannerData.length > 0 && <AdsSpaceSectionMainTheme2 adsDetails={bannerData} />}
      <div className="product-list-grid">
        {theme_type === "1" && secondHalf.length > 0 ?
          (secondHalf.map((product, index) => {
            return (
              <div className="product-list-grid-items" key={product.product_id || index}>
                <ProductCard product={product} />
              </div>
            );
          })) : (
            secondHalf.map((product, index) => {
              return (
                <div className="product-list-grid-items" key={product.product_id || index}>
                  <ProductCardTheme2 product={product} />
                </div>
              );
            })
          )
        }
      </div>
         </>
        )}
      </div>
        );
      })}
      {productList.length ? (
        <Pagination
          pages={productListByDepartmentTotalPages}
          current={page}
          onClick={handleSetPage}
        />
      ) : (
        ""
      )}
    </div>
  );
};

function DownArrowIcon({isOpen}) {
  return (
    <svg
     xmlns="http://www.w3.org/2000/svg"
     width="20"
     height="20"
     viewBox="0 0 48 48"
     style={{
       transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
       transition: "transform 0.3s ease"
     }}
   >
     <path
       fill="none"
       stroke="#000"
       strokeLinecap="round"
       strokeLinejoin="round"
       strokeWidth="4"
       d="M36 18L24 30L12 18"
     />
   </svg>
  )
}

export default ProductList;
